import SilenceSound from '@static/media/sounds/silence_1s.mp3'
import ExperienceBgmSound from '@static/media/sounds/bgmWater.mp3'
import ExperienceTapSound from '@static/media/sounds/seTap.mp3'
import ExperienceDolphinSound from '@static/media/sounds/seBluewhale3.mp3'
import ExperienceTrashSpawnSound from '@static/media/sounds/seBottle.mp3'

const letseeMapData = {
  tower: { lat: 37.50567005696035, lng: 127.0578723329876 },
  house: { lat: 37.50690678548065, lng: 127.0576697076448 },
}
const museumMapData = {
  tower: { lat: 36.78052262213724, lng: 127.22766271801974 },
  house: { lat: 36.78337152186593, lng: 127.22336928632065 },
}
const temp01MapData = {
  tower: { lat: 37.50504681602219, lng: 127.07644241430735 },
  house: { lat: 37.50337013575773, lng: 127.07768474627534 },
}
export const MAP_INFO = {
  letsee: { lat: 37.5060528089097, lng: 127.0582288894682, zoom: 4, data: letseeMapData },
  museum: { lat: 36.7818560824031, lng: 127.22539534802569, zoom: 4, data: museumMapData },
  temp01: { lat: 37.50417168668183, lng: 127.07820581786842, zoom: 4, data: temp01MapData },
}
export const MAP_MODE = 'museum' // [letsee, museum, temp01]

export const experienceSoundData = [
  { src: SilenceSound, name: 'silence-1s', html5: true },
  { src: ExperienceBgmSound, name: 'experience-bgm', loop: true },
  { src: ExperienceDolphinSound, name: 'experience-dolphin', loop: true },
  { src: ExperienceTapSound, name: 'experience-tap', pool: 5 },
  { src: ExperienceTrashSpawnSound, name: 'experience-trash-spawn', pool: 5 },
]

import collectionShape1 from '@static/media/images/collection/collection.shape.1.svg'
import collectionShape2 from '@static/media/images/collection/collection.shape.2.svg'
import collectionShape3 from '@static/media/images/collection/collection.shape.3.svg'
import collectionShape4 from '@static/media/images/collection/collection.shape.4.svg'
import collectionShape5 from '@static/media/images/collection/collection.shape.5.svg'
import collectionShape6 from '@static/media/images/collection/collection.shape.6.svg'
import collectionShape7 from '@static/media/images/collection/collection.shape.7.svg'
import collectionShape8 from '@static/media/images/collection/collection.shape.8.svg'
import collectionBig1 from '@static/media/images/collection/collection.big.1.webp'
import collectionBig2 from '@static/media/images/collection/collection.big.2.webp'
import collectionBig3 from '@static/media/images/collection/collection.big.3.webp'
import collectionBig4 from '@static/media/images/collection/collection.big.4.webp'
import collectionBig5 from '@static/media/images/collection/collection.big.5.webp'
import collectionBig6 from '@static/media/images/collection/collection.big.6.webp'
import collectionBig7 from '@static/media/images/collection/collection.big.7.webp'
import collectionBig8 from '@static/media/images/collection/collection.big.8.webp'

export const collectionData = [
  {
    id: '1',
    title: '하트 고래',
    img_shape: collectionShape1,
    img_big: collectionBig1,
  },
  {
    id: '2',
    title: '줄무늬 고래',
    img_shape: collectionShape2,
    img_big: collectionBig2,
  },
  {
    id: '3',
    title: '보석 고래',
    img_shape: collectionShape3,
    img_big: collectionBig3,
  },
  {
    id: '4',
    title: '물방울 고래',
    img_shape: collectionShape4,
    img_big: collectionBig4,
  },
  {
    id: '5',
    title: '꽃잎 고래',
    img_shape: collectionShape5,
    img_big: collectionBig5,
  },
  {
    id: '6',
    title: '상자 고래',
    img_shape: collectionShape6,
    img_big: collectionBig6,
  },
  {
    id: '7',
    title: '다각 고래',
    img_shape: collectionShape7,
    img_big: collectionBig7,
  },
  {
    id: '8',
    title: '동그라미 고래',
    img_shape: collectionShape8,
    img_big: collectionBig8,
  },
]
